import { RespuestaLecturaError } from '../Mensajes';
import { llamadaAPI_GET, llamadaAPI_POST } from '../SQL';
import { TratamientoDeParametroParaURI } from '../Varios';
import { function_ABM_CON_CuentasFinancieras_Leer } from '../ABM/CONT/ABM_CON_CuentasFinancieras';
import { function_ABM_CON_Monedas_Leer } from '../ABM/CONT/ABM_CON_Monedas';

export const function_CON_Plantilla_OperacionesParaImportar_Cabecera_Listar = async () => {
    const NombreFuncion = "function_CON_Plantilla_OperacionesParaImportar_Cabecera_Listar"

    try {
        const resulData = await llamadaAPI_GET("CON_Plantilla_OperacionesParaImportar_Cabecera/Listar/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta"));
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CON_Plantilla_OperacionesParaImportar_Cabecera_Leer = async (IdPlantilla) => {
    const NombreFuncion = "function_CON_Plantilla_OperacionesParaImportar_Cabecera_Leer"

    try {
        const resulData = await llamadaAPI_GET("CON_Plantilla_OperacionesParaImportar_Cabecera/Leer/" +
            localStorage.getItem("CodigoCompania") + "/" +
            localStorage.getItem("CodigoEmpresa") + "/" +
            localStorage.getItem("CodigoPlanta") + "/" +
            IdPlantilla);
        return resulData;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error)
        throw error;
    }
};

export const function_CON_Plantilla_OperacionesParaImportar_Cabecera_Generar_JSON = async (Fecha, CodigoCuentaFinancieraOrigen, CodigoCuentaFinancieraDestino, 
    CodigoSubCCOrigen, CodigoSubCCDestino, IdCheque, ImporteOrigen, ImporteDestino,
    Concepto, Observacion, Comprobante,     
    CodigoCuentaContableOrigen, CodigoCuentaContableDestino ) => {
    const NombreFuncion = "function_CON_Plantilla_OperacionesParaImportar_Cabecera_Generar_JSON";

    try {
        
        // Validaciones
        if (!ImporteOrigen || isNaN(ImporteOrigen) || ImporteOrigen <= 0) {
            throw new Error("El Importe debe ser mayor a cero.");
        }
        
        if (!ImporteDestino || isNaN(ImporteDestino) || ImporteDestino <= 0) {
            throw new Error("El Importe debe ser mayor a cero.");
        }

        const cuentaFinancieraOrigenResult = await function_ABM_CON_CuentasFinancieras_Leer(CodigoCuentaFinancieraOrigen)
        const monedaOrigenResult = await function_ABM_CON_Monedas_Leer(cuentaFinancieraOrigenResult.data[0].CodigoMoneda)
        
        const cuentaFinancieraDestinoResult = await function_ABM_CON_CuentasFinancieras_Leer(CodigoCuentaFinancieraDestino)
        const monedaDestinoResult = await function_ABM_CON_Monedas_Leer(cuentaFinancieraDestinoResult.data[0].CodigoMoneda)

        const JSON = {
            Fecha: Fecha,
            CodigoCompania: localStorage.getItem("CodigoCompania"),
            CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
            CodigoPlanta: localStorage.getItem("CodigoPlanta"),
            CodigoCuentaFinancieraOrigen: CodigoCuentaFinancieraOrigen, 
            CodigoCuentaFinancieraDestino: CodigoCuentaFinancieraDestino, 
            CodigoSubCCOrigen: CodigoSubCCOrigen,
            CodigoSubCCDestino: CodigoSubCCDestino, 
            IdCheque: IdCheque, 
            ImporteOrigen: ImporteOrigen, 
            CodigoMonedaOrigen: monedaOrigenResult.data[0].CodigoMoneda, 
            CotizacionOrigen: monedaOrigenResult.data[0].Cotizacion, 
            ImporteDestino: ImporteDestino,
            CodigoMonedaDestino: monedaDestinoResult.data[0].CodigoMoneda, 
            CotizacionDestino: monedaDestinoResult.data[0].Cotizacion, 
            Concepto: Concepto, 
            Observacion: Observacion, 
            Comprobante: Comprobante, 
            IdEstado: 10, 
            Terminal: localStorage.getItem("Terminal"), 
            CodigoCuentaContableOrigen: CodigoCuentaContableOrigen, 
            CodigoCuentaContableDestino: CodigoCuentaContableDestino
        };

        return JSON;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};

export const function_CON_Plantilla_OperacionesParaImportar_Cabecera_Insertar = async (Operacion) => {
    const NombreFuncion = "function_CON_Plantilla_OperacionesParaImportar_Cabecera_Insertar";

    try {
        const operacionResult = await llamadaAPI_POST("CON_Plantilla_OperacionesParaImportar_Cabecera/InsertarCompleto/",
            Operacion);
        return operacionResult;
    } catch (error) {
        RespuestaLecturaError(localStorage.getItem("CodigoCompania"), NombreFuncion, error);
        throw error;
    }
};